import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  News,
  SpacerV,
  Stats,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { Grid } from "@mui/material";
import { FeatureCard } from "../components/Hero";
import { FeatureCardSmall } from "../components/Hero";
import CellTowerIcon from "@mui/icons-material/CellTower";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import WorkIcon from "@mui/icons-material/Work";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import BuildIcon from "@mui/icons-material/Build";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PersonIcon from "@mui/icons-material/Person";
import Lottie from "react-lottie";
import { TypeAnimation } from "react-type-animation";
import { FAQ } from "../components/Sections";

export default function About() {
  useEffect(() => {
    axios
      .get(API_URL + "get_people")
      .then((res) => {
        setPeople(res.data);
      })
      .catch(() => {});
    axios
      .get(API_URL + "get_gallery")
      .then((res) => {
        setGallery(res.data);
      })
      .catch(() => {});
  }, []);
  const [people, setPeople] = useState([]);
  const [gallery, setGallery] = useState([]);

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <Sidebar />
        <div className="anigrad">
          <div
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: state.auth.isMobile ? "-6vh" : "0px",
                  fontSize: state.auth.isMobile ? "30px" : "8.75vh",
                  color: "white",
                  zIndex: 999,
                }}
              >
                <h1>
                  Riches Media Digital
                  <br />
                  <span style={{ color: "yellow", fontWeight: "bold" }}>
                    #1 Digital Marketing Agency
                  </span>
                </h1>
              </div>

              <div
                style={{
                  borderBottom: "2px solid white",
                  width: "100%",
                  margin: "25px 0px 25px 0px",
                }}
              ></div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "30px" : "4.4vh",
                  color: "white",
                  zIndex: 999,
                }}
              >
                We’re on a mission to empower start-ups{" "}
                <b style={{ color: "yellow" }}>worldwide</b>.
              </div>
            </div>
          </div>
        </div>

        <ContentSideBySideInv
          title={<h2>How we started</h2>}
          subtitle="Praveen Muthigi is the visionary founder and dynamic CEO of Riches Media Digital, a pioneering force in the digital marketing industry. With a relentless passion for innovation and a keen eye for emerging trends, Praveen has steered the company to remarkable heights since its inception. His strategic prowess, combined with an unwavering commitment to client success, has earned Riches Media Digital a reputation for delivering exceptional results in the ever-evolving digital landscape. Praveen’s leadership is characterized by a deep understanding of digital marketing’s intricacies, a dedication to client satisfaction, and a relentless drive to push boundaries, making him a true trailblazer in the field."
          image={
            <img
              style={{
                width: "100%",
                borderRadius: "25px",
                maxHeight: state.auth.isMobile ? "none" : "70vh",
                objectFit: "contain",
                objectPosition: "center",
                padding: state.auth.isMobile ? "15px" : "0px",
              }}
              alt={"Praveen Muthigi, CEO of Riches Media Digital"}
              src={require("../img/about-us-praveen.jpeg")}
            />
          }
        />
        {state.auth.isMobile ? (
          <SpacerV height={"200px"} background="white" />
        ) : (
          ""
        )}

        <ContentSideBySide
          title={<h2>What makes us who we are today…</h2>}
          subtitle="Riches Media Digital is a team of strategists, creative directors, designers, technologists, developers, and relationship builders. We are committed to creating vibrant and relevant experiences for our clients at every level, using our product and technology expertise.​In the era of digital transformation, we deliver human-shaped experiences at the intersection of strategy, design, and technology. We have invested in building strong competency, innovation hubs, and labs to cater to cutting-edge technologies like Cybersecurity, cloud, Internet of Things (IoT), and Artificial Intelligence (AI).​​"
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/marketing (8).json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />

        <SpacerV height={"100px"} background="white" />
        <Stats />
        <FAQ />

        <div
          className="anigrad"
          style={{
            textAlign: "center",
            padding: state.auth.isMobile ? "2.2vh" : "100px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <Grid
            style={{
              display: "flex",
              justifyContent: "center",
            }}
            container
            spacing={5}
          >
            <Grid
              item
              md={3}
              xs={10}
              sm={10}
              style={{
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "start",
                flexDirection: "column",
                alignItems: "start",
                fontSize: "6vh",
                color: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              <h2>
                What is <span style={{ color: "yellow" }}>imprinted</span> in
                our DNA.
              </h2>
            </Grid>
            <Grid
              item
              md={8}
              xs={10}
              sm={10}
              style={{
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "start",
                flexDirection: "column",
                alignItems: "start",
                fontSize: "6vh",
                color: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              <div
                style={{
                  fontSize: state.auth.isMobile ? "30px" : "4.4vh",
                  color: "#ddd",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                <h3>Mission</h3>
              </div>

              <div
                style={{
                  fontSize: "2.2vh",
                  color: "white",
                  cursor: "pointer",
                }}
              >
                Riches Media Digital exists to remove guesswork from digital
                performance. Our mission is to deliver media strategies that are
                rooted in data and built for outcomes. Every plan we develop
                must serve a business goal. Every campaign must earn its place
                by driving measurable value.
                <br /> <br />
                We work to align platforms with purpose. Paid campaigns, organic
                growth, and content strategies are managed with one objective,
                efficient performance. No channel is used without clarity, and
                no budget is applied without expected return.
                <br /> <br />
                Our mission is not to follow what’s trending. It is to focus on
                what scales, what tracks, and what brings our clients closer to
                revenue and retention.
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "30px" : "4.4vh",
                  color: "#ddd",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                <h3>Vision</h3>
              </div>
              <div
                style={{
                  fontSize: "2.2vh",
                  color: "white",
                  cursor: "pointer",
                }}
              >
                Our vision is to become the performance partner that
                growth-driven brands rely on. We want every client to move from
                reaction to precision. That shift happens when strategy meets
                structure and every digital step aligns with broader business
                goals.
                <br /> <br /> We see a future where campaigns no longer exist in
                isolation. Media, content, and data must work together. Brands
                should expect real visibility into what’s working and what needs
                to change. <br /> <br />
                The vision is not complexity. It is clarity. And we believe
                digital growth becomes achievable when platforms, people, and
                purpose are aligned in execution.
              </div>
              <div
                style={{
                  margin: "25px 0px 25px 0px",
                  borderBottom: "1px solid #ddd",
                }}
              ></div>
            </Grid>
          </Grid>
        </div>
        <ContentSideBySideInv
          title="We believe that the human dimensions essential to start any successful project and that this is where splendid emotional relationships between the company and people are born."
          subtitle=""
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/work.json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />

        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
